import * as HighCharts from 'highcharts/highstock'; // tslint:disable-line
import { Component } from 'react';
class LinearChart extends Component<any> {
  private chart: any;
  public componentDidMount() {
    this.loadChart();
  }
  public loadChart() {
    const { graphData, categoryData, graphConfig, category, name } = this.props;

    this.chart = new HighCharts.StockChart('chart-container', {
      ...graphConfig,
      series: [
        {
          name,
          data: graphData || [],
          tooltip: {
            valueDecimals: 2,
          },
        },
        {
          name: category,
          data: categoryData || [],
          tooltip: {
            valueDecimals: 2,
          },
        },
      ],
    });
  }

  public componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  public render() {
    return (
      <div
        id="chart-container"
        style={{
          minWidth: 310,
          height: 400,
          margin: '0 auto',
        }}
      />
    );
  }
}

export default LinearChart;



// WEBPACK FOOTER //
// ./components/singleFund/LinearChart.tsx